export const renderTextOrNonValue = (
  verifyValue?: string | number,
  showValue = verifyValue
) => {
  return verifyValue === 0 || !verifyValue ? '--' : showValue;
};
